export const BASE_URL = process.env.REACT_APP_BASE_URL



// WEBPACK FOOTER //
// ./src/services/constants.js